import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section id="categorias" className="py-16 md:py-24 px-4 md:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <p className="text-accent-500 font-semibold text-xs tracking-[0.2em] uppercase">CSSBUY / BIZ</p>
          <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-900">Categorias Populares</h2>
          <p className="mt-3 text-foreground-500 text-sm max-w-xl">
            Explore nossas categorias de CSSBuy Spreadsheet com links verificados e organizados para cada tipo de produto.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden cursor-pointer h-48 md:h-56 p-0 hover:shadow-md transition-all"
            data-product-shop
          >
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20sneaker%20product%20photography%20single%20pair%20of%20white%20designer%20sneakers%20placed%20on%20warm%20cream%20surface%20soft%20natural%20side%20lighting%20casting%20gentle%20shadows%20editorial%20style%20clean%20composition%20neutral%20beige%20background%20simple%20elegant%20aesthetic&width=600&height=450&seq=cat-v2-tenis&orientation=landscape"
                alt="Tênis"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/80 via-foreground-900/15 to-transparent"></div>
            </div>
            <div className="relative z-10 p-5 flex flex-col justify-end h-full">
              <h3 className="text-background-50 text-xl md:text-2xl font-heading font-bold">Tênis</h3>
              <span className="text-background-50/70 text-xs mt-1 inline-block whitespace-nowrap">Ver Spreadsheet →</span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden cursor-pointer h-48 md:h-56 p-0 hover:shadow-md transition-all"
            data-product-shop
          >
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20streetwear%20fashion%20flat%20lay%20with%20oversized%20hoodie%20and%20cap%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20product%20photography%20clean%20aesthetic%20neutral%20beige%20tones%20textile%20texture%20subtle%20folds&width=600&height=450&seq=cat-v2-streetwear&orientation=landscape"
                alt="Streetwear"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/80 via-foreground-900/15 to-transparent"></div>
            </div>
            <div className="relative z-10 p-5 flex flex-col justify-end h-full">
              <h3 className="text-background-50 text-xl md:text-2xl font-heading font-bold">Roupas</h3>
              <span className="text-background-50/70 text-xs mt-1 inline-block whitespace-nowrap">Ver Spreadsheet →</span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden cursor-pointer h-48 md:h-56 p-0 hover:shadow-md transition-all"
            data-product-shop
          >
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20basketball%20sneaker%20product%20photography%20iconic%20Jordan%20style%20shoe%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20clean%20composition%20neutral%20beige%20background%20artistic%20shadows%20modern%20aesthetic&width=600&height=450&seq=cat-v2-jordan&orientation=landscape"
                alt="Jordan"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/80 via-foreground-900/15 to-transparent"></div>
            </div>
            <div className="relative z-10 p-5 flex flex-col justify-end h-full">
              <h3 className="text-background-50 text-xl md:text-2xl font-heading font-bold">Jordan</h3>
              <span className="text-background-50/70 text-xs mt-1 inline-block whitespace-nowrap">Ver Spreadsheet →</span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden cursor-pointer h-48 md:h-56 p-0 hover:shadow-md transition-all"
            data-product-shop
          >
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20Nike%20running%20sneaker%20product%20photography%20single%20shoe%20on%20warm%20cream%20surface%20soft%20natural%20light%20editorial%20style%20clean%20composition%20neutral%20beige%20background%20subtle%20reflections%20modern%20athletic%20aesthetic&width=600&height=450&seq=cat-v2-nike&orientation=landscape"
                alt="Nike"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/80 via-foreground-900/15 to-transparent"></div>
            </div>
            <div className="relative z-10 p-5 flex flex-col justify-end h-full">
              <h3 className="text-background-50 text-xl md:text-2xl font-heading font-bold">Nike</h3>
              <span className="text-background-50/70 text-xs mt-1 inline-block whitespace-nowrap">Ver Spreadsheet →</span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden cursor-pointer h-48 md:h-56 p-0 hover:shadow-md transition-all"
            data-product-shop
          >
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20Yeezy%20style%20sneaker%20product%20photography%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20clean%20composition%20neutral%20beige%20background%20subtle%20shadows%20contemporary%20streetwear%20aesthetic&width=600&height=450&seq=cat-v2-yeezy&orientation=landscape"
                alt="Yeezy"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/80 via-foreground-900/15 to-transparent"></div>
            </div>
            <div className="relative z-10 p-5 flex flex-col justify-end h-full">
              <h3 className="text-background-50 text-xl md:text-2xl font-heading font-bold">Yeezy</h3>
              <span className="text-background-50/70 text-xs mt-1 inline-block whitespace-nowrap">Ver Spreadsheet →</span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden cursor-pointer h-48 md:h-56 p-0 hover:shadow-md transition-all"
            data-product-shop
          >
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20luxury%20designer%20handbag%20product%20photography%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20style%20clean%20composition%20neutral%20beige%20background%20elegant%20aesthetic%20subtle%20highlights%20premium%20feel&width=600&height=450&seq=cat-v2-designer&orientation=landscape"
                alt="Designer"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/80 via-foreground-900/15 to-transparent"></div>
            </div>
            <div className="relative z-10 p-5 flex flex-col justify-end h-full">
              <h3 className="text-background-50 text-xl md:text-2xl font-heading font-bold">Designer</h3>
              <span className="text-background-50/70 text-xs mt-1 inline-block whitespace-nowrap">Ver Spreadsheet →</span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden cursor-pointer h-48 md:h-56 p-0 hover:shadow-md transition-all"
            data-product-shop
          >
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20football%20soccer%20jersey%20product%20photography%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20style%20clean%20composition%20neutral%20beige%20background%20folded%20fabric%20texture%20sporty%20aesthetic&width=600&height=450&seq=cat-v2-football&orientation=landscape"
                alt="Football"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/80 via-foreground-900/15 to-transparent"></div>
            </div>
            <div className="relative z-10 p-5 flex flex-col justify-end h-full">
              <h3 className="text-background-50 text-xl md:text-2xl font-heading font-bold">Football</h3>
              <span className="text-background-50/70 text-xs mt-1 inline-block whitespace-nowrap">Ver Spreadsheet →</span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden cursor-pointer h-48 md:h-56 p-0 hover:shadow-md transition-all"
            data-product-shop
          >
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20fashion%20accessories%20product%20photography%20sunglasses%20watch%20and%20bracelet%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20style%20clean%20composition%20neutral%20beige%20background%20elegant%20refined%20aesthetic&width=600&height=450&seq=cat-v2-acessorios&orientation=landscape"
                alt="Acessórios"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/80 via-foreground-900/15 to-transparent"></div>
            </div>
            <div className="relative z-10 p-5 flex flex-col justify-end h-full">
              <h3 className="text-background-50 text-xl md:text-2xl font-heading font-bold">Acessórios</h3>
              <span className="text-background-50/70 text-xs mt-1 inline-block whitespace-nowrap">Ver Spreadsheet →</span>
            </div>
          </a>
        </div>

        <div className="mt-10">
          <p className="text-foreground-500 text-sm mb-4">Todas as categorias disponíveis:</p>
          <div className="flex flex-wrap gap-2">
            {categories.map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="px-4 py-2 rounded-full bg-background-50 border border-background-200 text-foreground-600 text-xs hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 transition-all whitespace-nowrap cursor-pointer"
              >
                {cat.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}